import {Record as record} from 'immutable';

export default record(
    {
        currentDate: null,
        children: 0,
        adults: 0,
        hasPets: false,
        arriveDateText: '',
        departDateText: '',
        arriveEditing: false,
        departEditing: true,
        alertIcon: null,
        arrivedWithoutDates: false,
        isBookingFlow: false,
        isFamilySegment: false
    },
    'TripRecord'
);
